import React from 'react';
import './Rate.css';
import RateCur from "../RateCur/RateCur";

class Rate extends React.Component {
    constructor(props) {
        super(props);
        let date = new Date();
        this.state = {
            'currenciesRates' : {},
            'popCurrRates' : {},
            'date' : date.toLocaleDateString(),
        };
        this.getRate();
    }
    getRate = () => {
        fetch(`https://api.privatbank.ua/p24api/pubinfo?exchange&json&coursid=11`)
            .then(data => {
                return data.json()
            })
            .then(data => {
                this.setState({currenciesRates : data});
                let popRates = [];
                for (let i = 0; i < 3; i++) {
                    popRates.push(this.state.currenciesRates[i])
                }
                this.setState({'popCurrRates' : popRates})
            })
    };
    render() {
        return (
            <div className="rates">
                <div className="container">
                    <h4 className="content-title">Курс валют станом на {this.state.date}</h4>
                    <div className="row justify-content-between">
                        {Object.keys(this.state.popCurrRates).map( (keyName, i) => (
                            <RateCur
                                key={keyName}
                                ccy={this.state.popCurrRates[keyName]['ccy']}
                                buy={this.state.popCurrRates[keyName]['buy']}
                                sale={this.state.popCurrRates[keyName]['sale']}>

                            </RateCur>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default Rate;